import React, { useState } from 'react'
import { Alert, Button, Col, Form, Icon, Input, Radio, Row, Tag } from 'antd'
import { ButtonEx } from '../../../../../../styles/button.style'
import { useDeepEffect } from '../../../../../../utils/hooks'
import _, { isNull } from 'lodash'

const UpdateDevice = ({ form, onOk, onCancel, heroId, device }) => {
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          heroId: heroId,
          deviceAvailable: values.deviceAvailable
        }
        onOk(data)
      }
    })
  }

  return (
    <Form onSubmit={onSubmit} layout="vertical">
      <Form.Item label="Device Available">
        {getFieldDecorator(`deviceAvailable`, {
          initialValue: device,
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(<Input type="number" min="1" />)}
      </Form.Item>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ยกเลิก</Button>
        </Col>
        <Col>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            บันทึก
          </ButtonEx>
        </Col>
      </Row>
    </Form>
  )
}

const WrappedUpdateDevice = Form.create({ name: 'UpdateDevice' })(UpdateDevice)
export default WrappedUpdateDevice